import React, { useState } from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  FlatList,
  TextInput,
} from "react-native";
import Header from "../../component/header";
import Background from "../../component/background";
import "react-minimal-datetime-range/lib/react-minimal-datetime-range.min.css";
import CompeCreate from "../../component/compeCreate";
const { width, height } = Dimensions.get("window");
export default function index({ navigation, route }) {
  return (
    <View style={styles.container}>
      <Header
        backgroundColorCompetition="#FFFFFF"
        Admin
        navigation={navigation}
      />
      <ScrollView>
        <View>
          <Background
            navigation={navigation}
            navigation={navigation}
            Title="COMPETITION/CREATE"
            admin
          />
          <CompeCreate route={route} textButtonSend navigation={navigation} />
        </View>
      </ScrollView>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#CCE4FF",
    flexDirection: "row",
  },
});
